export default "__VITE_ASSET__DcPoMu$j__"